<template>
    <v-sheet>
        <div class="mb-12 mb-lg-16">
            <form-baseinfo-application-toggle v-model="application" @change="emit" />
        </div>
        <v-row align="center">
            <v-col cols="12" lg="auto">
                <v-row align="center" class="row--small">
                    <v-col lg="auto" class="mb-10 mb-lg-0">
                        <datetime-picker-field v-model="application.startsAt" label="접수기간(시작)" hideTime v-bind="{ attrs_input: { disabled, dense: true, outlined: true, hideDetails: true, persistentPlaceholder: true, class: 'min-w-200px min-w-xl-260px' } }" @input="emit" />
                    </v-col>
                    <v-col cols="auto">
                        ~
                    </v-col>
                    <v-col cols="12" lg="auto">
                        <datetime-picker-field v-model="application.endsAt" label="접수기간(종료)" v-bind="{ attrs_input: { disabled, dense: true, outlined: true, hideDetails: true, persistentPlaceholder: true, class: 'min-w-200px min-w-xl-260px' } }" @input="emit" />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="auto"> <v-checkbox v-model="application.closesOnHiring" label="채용 시 마감" hide-details @change="emit" /> </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { initRecruitmentField__application } from "@/assets/variables";

import DatetimePickerField from "@/components/dumb/datetime-picker-field.vue";
import FormBaseinfoApplicationToggle from "./form-baseinfo-application-toggle.vue";

export default {
    components: {
        DatetimePickerField,
        FormBaseinfoApplicationToggle,
    },
    props: {
        value: { type: Object, default: initRecruitmentField__application },
    },
    data: () => ({
        application: initRecruitmentField__application(),
    }),
    computed: {
        disabled() {
            return this.value?.isOpenHiring;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.application = initRecruitmentField__application(this.value);
        },
        emit() {
            this.$emit("input", initRecruitmentField__application(this.application));
        },
    },
};
</script>

<style>
</style>